<template>
  <div>
    <v-card flat>
      <v-card-text class = "pa-0" style="margin-top:40px">
        <form style="display:flex; align-items:center"
          id = "regfileform"
          ref = "regfileform"
        >
          <v-container
            fluid
            justify-center
          >
            <v-layout
              class = "mt-1 pt-1"
              wrap
              justify-center
              align-content-center
            >
              <v-flex xs12>
                <v-img
                  :src = "uploadPdfSrc"
                  style = "height: 128px; width: 128px; margin: auto;"
                />
              </v-flex>
              <v-flex xs12 class = "text-center">
                <!-- <span class = "primary--text"> -->
                  <!-- {{ $t('headers.uploading-file') }} -->
                  <h3>Для начала перетащите сюда файл.</h3>
                <!-- </span> -->
              </v-flex>
              <v-flex
                xs12
                class = "text-center pa-0 ma-0"
              >
                <v-btn
                  color = "warning"
                  @click = "handleUpload"
                  class="mt-4"
                >
                  <!-- {{ $t('buttons.upload') }} -->
                  Загрузить
                </v-btn>
                <input
                  ref = "fileInput"
                  type = "file"
                  style = "display: none;"
                  @change = "onFileChange"
                >
              </v-flex>
              <v-flex xs12 class = "text-center mt-5" style="word-break: break-word;">
                Расчёт контрольных сумм будет производиться на Вашем устройстве.
              </v-flex>
              <v-flex xs12 class = "text-center" style="word-break: break-word;">
                Файл в интернет не перекачивается.
              </v-flex>

            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
    <DemoLabel/>
  </div>
</template>

<script>
import { isDemo } from '../environment'
import DemoLabel from './DemoLabel.vue'


export default {
  components: {
    DemoLabel,
  },
  data () {
    return {
      uploadPdfSrc: require('@/assets/upload-pdf.png'),
      dragAndDropCapable: false
    }
  },
  computed: {
    isDemo() {
      return isDemo
    }
  },
  methods: {
    handleUpload () {
      return this.$refs.fileInput.click()
    },
    onFileChange (event) {
      this.uploadFile(event.target.files[0])
    },
    uploadFile (file) {
      this.$store.dispatch('uploadFile', file)
      this.$router.push({
        name: 'RegFinish',
      })
    },
    determineDragAndDropCapable () {
      let div = document.createElement('div')
      return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) )
        && 'FormData' in window
        && 'FileReader' in window
    }
  },
  mounted () {
    this.dragAndDropCapable = this.determineDragAndDropCapable()
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function(evt) {
        this.$refs.regfileform.addEventListener(evt, function(e) {
          e.preventDefault()
          e.stopPropagation()
        }.bind(this), false)
      }.bind(this))
      this.$refs.regfileform.addEventListener('drop', function(e) {
        this.uploadFile(e.dataTransfer.files[0])
      }.bind(this))
    }
  },
  created () {
  }
}
</script>

<style>
  #regfileform {
    display: block;
    height: 400px;
    margin: auto;
    background-position: top;
    background-size: 10px 1px;
    background-repeat: repeat-x;
    border-color: #1867c0;
    border-width: 2px;
    border-style: dashed;
    border-style: dashed;
    border-radius: 4px;
  }

  #regfileform:hover {
    background: #ddd;
  }
</style>